<!-- @format -->

@let stepKeys = wizardStepKeys();
@if (!!stepKeys && stepKeys.length > 0) {
  @let stepIndex = currentWizardStepIndex();
  @if (stepIndex >= 0 && stepIndex < stepKeys.length) {
    <!-- Assuming there's somewhere a <h1> above this component -->
    <fudis-heading [level]="2" *transloco="let t" data-cy="cart-wizard-step-title"
      >{{ stepIndex + 1 }}. {{ t(stepKeys[stepIndex]) }}</fudis-heading
    >
  }
}
